import store from '../store';
import { uiBlockActions } from '../store/uiBlock';

export const uiBlockService = {
    block: () => store.dispatch(uiBlockActions.block()),
    blockWithBackground: () => store.dispatch(uiBlockActions.blockWithBackground()),
    unBlock: () => store.dispatch(uiBlockActions.unBlock())
};
